import script from "./CanteenDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CanteenDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CanteenDashboard.vue?vue&type=style&index=0&id=9039988a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9039988a"]])

export default __exports__